module.exports = __webpack_public_path__ + "img/bild-b.6b2f6916.png";